export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            了解51吃瓜视频的品牌故事与平台理念
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="bg-background-50 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="space-y-5">
              <div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">
                  关于51吃瓜视频
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  51吃瓜视频成立于2020年，是国内领先的吃瓜爆料视频聚合平台。我们致力于为用户提供最新、最全、最真实的娱乐八卦、明星动态、社会热点等视频内容。通过51吃瓜官网全网最新入口，用户可以一站式浏览海量吃瓜资源。作为51吃瓜视频网官方平台，我们始终坚持内容质量优先、用户体验至上的原则，持续优化技术架构，保障访问速度与稳定性。目前平台已覆盖PC网页端、移动网页端以及iOS和Android双平台APP，累计服务超过千万吃瓜爱好者。
                </p>
              </div>
              <div>
                <h3 className="font-heading text-lg text-foreground-900 mb-3">
                  平台特色
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  51吃瓜视频网以"快、全、真"为核心特色——快，全天候追踪全网热点，第一时间同步更新；全，覆盖娱乐、综艺、网红、影视、音乐等多个领域；真，坚持内容审核机制，杜绝虚假谣言。本站作为51吃瓜网站首页官方入口，持续优化用户浏览体验，并开放投稿合作通道，欢迎每一位热爱吃瓜的朋友加入我们的内容生态。
                </p>
              </div>
              <div className="flex flex-wrap gap-4 pt-2">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                    <i className="ri-team-line text-sm"></i>
                  </div>
                  <span>专业编辑团队全天候运营</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                    <i className="ri-user-smile-line text-sm"></i>
                  </div>
                  <span>累计服务千万级用户</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                    <i className="ri-vidicon-line text-sm"></i>
                  </div>
                  <span>日均更新50+条视频内容</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}